module.exports = __webpack_public_path__ + "static/media/offer_image_placeholder.da204f5f.jpeg";